import * as React from 'react';
import { Breadcrumb, BreadcrumbItem, Col, Row } from 'reactstrap';
import { convertToDisplay } from 'app/shared/util/date-utils';
import { localeToLangKey } from 'app/shared/util/locale-utils';
import { Translate, Storage, translate } from 'react-jhipster';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { IEvent } from 'app/shared/model/event.model';
import { ISession } from 'app/shared/model/session.model';
import * as moment from 'moment';
import { toast } from 'react-toastify';
import { isEventHasEnabledSessions } from './order-shared';

export interface IOrderBreadCrumbProps extends RouteComponentProps<{}> {
  step: any;
  currentLocale: string;
}

export interface IOrderBreadCrumbState {
  event: IEvent;
  session: ISession;
}

export class OrderBreadCrumb extends React.Component<IOrderBreadCrumbProps, IOrderBreadCrumbState> {
  state: IOrderBreadCrumbState = {
    event: { nameCht: '', nameEng: '' },
    session: { startTime: moment() }
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    const { step, currentLocale } = this.props;
    const event = Storage.session.get('EVENT');
    const session = Storage.session.get('SESSION');
    const orderToken = Storage.session.get('ORDER_TOKEN');
    const pi = Storage.session.get('PI');
    const transaction = Storage.session.get('TRANSACTION');
    let returnHome = false;

    // validate necessary info to view current page. Return home if necessary info is missing
    if (step >= 1) {
      // date selection
      if (event != null) this.setState({ event });
      else returnHome = true;
    }
    if (step >= 2) {
      // seat selection
      if (session != null) this.setState({ session });
      else returnHome = true;

      // check if have order token
      if (orderToken == null) returnHome = true;
    }
    if (step >= 3) {
      // pi info
      if (transaction == null) returnHome = true;
    }
    if (step >= 4) {
      // payment info
      if (transaction == null || pi == null) returnHome = true;
    }

    if (returnHome) this.props.history.push('/');

    // If assigned seat && in date-selection/seat-section, direct to personal info page
    if (transaction && (step === '1' || step === '2')) {
      toast.info(translate('home.reservedseatwarning'));
      this.props.history.push('/order/personal-info');
    }
  }
  render() {
    const { step } = this.props;
    const { event, session } = this.state;
    return (
      <Row className="justify-content-center">
        <Col md="11">
          <Breadcrumb tag="nav">
            <BreadcrumbItem active>
              1) <Translate contentKey="order.breadcrumb.date">選擇場次</Translate>
            </BreadcrumbItem>
            <BreadcrumbItem active={step > 1}>
              2）<Translate contentKey="order.breadcrumb.zoneticket">選擇票數</Translate>
            </BreadcrumbItem>
            <BreadcrumbItem active={step > 2}>
              3）<Translate contentKey="order.breadcrumb.pi">填寫個人資料</Translate>
            </BreadcrumbItem>
            <BreadcrumbItem active={step > 3}>
              4）<Translate contentKey="order.breadcrumb.payment">確認訂單及網上付款</Translate>
            </BreadcrumbItem>
          </Breadcrumb>
        </Col>
        <Col md="12" className="text-center">
          <h1 className="mt-3 mb-3">
            {event['name' + localeToLangKey(this.props.currentLocale)]}{' '}
            {!isEventHasEnabledSessions(event) && ( // moment().isAfter(moment('2018-12-21T11:30:00Z'))
              <h2 className="text-secondary">
                <Translate contentKey="order.breadcrumb.closed">網上訂購已經全部售罄。</Translate>
              </h2>
            )}
          </h1>
        </Col>
      </Row>
    );
  }
}

export default withRouter(OrderBreadCrumb);
